import { Text } from '@chakra-ui/react';

export const EventEndedMessage: React.FC = () => {
  return <Text>This event has ended</Text>;
};
